import { STORAGE_KEYS } from './src-config-miaw-constants.js';
import { getItemInWebStorageByKey, setItemInWebStorage } from './src-utils-miaw-web-storage-utils.js';

const storeOrganizationId = (organizationId) => {
  setItemInWebStorage(STORAGE_KEYS.ORGANIZATION_ID, organizationId);
};
const getOrganizationId = () => {
  return getItemInWebStorageByKey(STORAGE_KEYS.ORGANIZATION_ID);
};
const storeDeploymentDeveloperName = (deploymentDevName) => {
  setItemInWebStorage(STORAGE_KEYS.DEPLOYMENT_DEVELOPER_NAME, deploymentDevName);
};
const getDeploymentDeveloperName = () => {
  return getItemInWebStorageByKey(STORAGE_KEYS.DEPLOYMENT_DEVELOPER_NAME);
};
const storeSalesforceMessagingUrl = (messagingUrl) => {
  setItemInWebStorage(STORAGE_KEYS.MESSAGING_URL, messagingUrl);
};
const getSalesforceMessagingUrl = () => {
  return getItemInWebStorageByKey(STORAGE_KEYS.MESSAGING_URL);
};
const setJwt = (jwt) => {
  setItemInWebStorage(STORAGE_KEYS.JWT, jwt);
};
const getJwt = () => {
  return getItemInWebStorageByKey(STORAGE_KEYS.JWT);
};
const setDeploymentConfiguration = (configuration) => {
  setItemInWebStorage(STORAGE_KEYS.DEPLOYMENT_CONFIGURATION, JSON.stringify(configuration));
};
const setLastEventId = (id) => {
};
let conversationId;
const storeConversationId = (convId) => {
  conversationId = convId;
};
const getConversationId = () => {
  return conversationId;
};
const clearInMemoryData = () => {
  conversationId = void 0;
};

export { clearInMemoryData, getConversationId, getDeploymentDeveloperName, getJwt, getOrganizationId, getSalesforceMessagingUrl, setDeploymentConfiguration, setJwt, setLastEventId, storeConversationId, storeDeploymentDeveloperName, storeOrganizationId, storeSalesforceMessagingUrl };
//# sourceMappingURL=src-utils-miaw-chat-config.js.map
